shadow$provide[403] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec4 getGammaInColor(vec4 rgba) {
  return vec4(rgba.rgb * rgba.rgb, rgba.a);
}
`;

};